import React, { useState, Fragment } from "react";
import {
  FormGroup,
} from "reactstrap";
import Select from 'react-select';
import TextareaAutosize from "react-textarea-autosize";
import "./index.css";

interface LegalFileProps {
  isView: Boolean;
  attachment: any;
  onAttachmentToUploadDeleted?: Function;
  onExistingAttachmentDeleted?: Function;
  onAttachmentUpdated?: Function;
  isExistingAttachment?: Boolean;
  onImageClick?: Function;
  legalDocumentTypes?: any;
}

export default function LegalFile({
  isView,
  attachment,
  onAttachmentToUploadDeleted,
  onExistingAttachmentDeleted,
  onAttachmentUpdated,
  isExistingAttachment,
  onImageClick,
  legalDocumentTypes,
}: LegalFileProps) {

  const [attachmentToDisplay, setAttachmentToDisplay] = useState<any>({
    ...attachment,
  });

  let defaultSelectedLegalDocumentType = null;
  if (attachment.legal_document) {
    defaultSelectedLegalDocumentType = {
      value: attachment.legal_document?.id,
      label: attachment.legal_document?.name,
    };
  }
  const [selectedLegalDocumentType, setSelectedLegalDocumentType] = useState<any | null>(defaultSelectedLegalDocumentType);

  const imageClickHandler = () => {
    if (onImageClick) {
      onImageClick(attachment);
    }
  }

  const deleteAttachment = () => {
    if (onAttachmentToUploadDeleted) {
      onAttachmentToUploadDeleted(attachment);
    }
    if (onExistingAttachmentDeleted) {
      onExistingAttachmentDeleted(attachment);
    }
  }
  const onCaptionChange = (value:string) => {
    if (isExistingAttachment) {
      setAttachmentToDisplay({
        ...attachmentToDisplay,
        caption_text: value,
      });
    } else {
      setAttachmentToDisplay({
        ...attachmentToDisplay,
        captionText: value,
      });
    }
    if (onAttachmentUpdated) {
      onAttachmentUpdated(
        isExistingAttachment
          ? {
              ...attachmentToDisplay,
              caption_text: value,
            }
          : {
              ...attachmentToDisplay,
              captionText: value,
            }
      );
    }
  }
  const onLegalDocumentTypeChange = (selectedOption:any) => {
    setSelectedLegalDocumentType(selectedOption);
    let attachmentAfterUpdated = attachmentToDisplay;
    if (isExistingAttachment) {
      attachmentAfterUpdated.legal_document_id = selectedOption.value;
    } else {
      attachmentAfterUpdated.legalDocumentId = selectedOption.value;
    }
    setAttachmentToDisplay(attachmentAfterUpdated);
    if (onAttachmentUpdated) {
      onAttachmentUpdated(attachmentAfterUpdated);
    }
  }

  let fileType = '';
  let fileUrl = '';
  let fileName = '';
  let fileCaptionText = '';
  if (isExistingAttachment) {
    fileType = attachmentToDisplay?.file_type;
    fileUrl = attachmentToDisplay?.file_url;
    fileName = attachmentToDisplay?.file_name || 'File đính kèm';
    fileCaptionText = attachmentToDisplay?.caption_text;
  } else {
    fileType = attachmentToDisplay?.blob?.type;
    fileUrl = attachmentToDisplay?.url;
    fileName = attachmentToDisplay?.blob?.name;
    fileCaptionText = attachmentToDisplay?.captionText;
  }

  const legalDocumentTypesOptions = legalDocumentTypes.map((legalDocumentType:any) => {
    return {
      value: legalDocumentType.id,
      label: legalDocumentType.name,
    };
  });

  if (isView) {
    return (
      <div style={styles.containerView}>
        {fileType?.includes('image') ?
          <div
            className="site-image-component__image-wrapper"
            style={{
              backgroundImage: `url(${fileUrl})`,
              ...styles.imageAttachmentView,
            }}
            onClick={imageClickHandler}
          />
          :
          <div style={styles.fileAttachmentView}>
            <a href={fileUrl}>
              {fileName}
            </a>
          </div>
        }
        <span style={styles.legalDocumentName}>{attachment.legal_document?.name}</span><br />
        <span style={styles.userName}>
          {`${attachment.user?.first_name} ${attachment.user?.last_name}`}
        </span><br />
        <span style={styles.captionText}>{fileCaptionText}</span>
      </div>
    );
  } else {
    return (
      <div style={styles.container}>
        <Fragment>
          <div>
            {fileType?.includes('image') ?
              <div
                style={{
                  backgroundImage: `url(${fileUrl})`,
                  ...styles.imageAttachment,
                }}
                onClick={() => window.open(fileUrl, '_blank')}
              >
                <button
                  style={styles.imageAttachmentDeleteButton}
                  onClick={deleteAttachment}
                >
                  X
                </button>
              </div>
              :
              <div style={styles.fileAttachment}>
                <a href={fileUrl}>{fileName}</a>
                <button
                  style={styles.generalFileAttachmentDeleteButton}
                  onClick={deleteAttachment}
                >
                  X
                </button>
              </div>
            }
          </div>
          <div style={styles.info}>
            <FormGroup>
              <Select
                value={selectedLegalDocumentType}
                options={legalDocumentTypesOptions}
                placeholder="Chọn loại giấy tờ..."
                onChange={(selectedOption) => onLegalDocumentTypeChange(selectedOption)}
              />
            </FormGroup>
            <FormGroup>
              <TextareaAutosize
                type="textarea"
                className="custom-textarea"
                placeholder="Caption cho file..."
                minRows={3}
                value={fileCaptionText}
                onChange={(e) => onCaptionChange(e.target.value)}
              />
            </FormGroup>
          </div>
        </Fragment>
      </div>
    );
  }
}

const styles = {
  containerView: {
    marginBottom: 12,
  },
  container: {
    display: 'flex',
    marginBottom: 12,
  },
  customTextInput: {
    marginTop: 20,
  },
  imageNote: {
    marginTop: 12,
  },
  commentButtonContainer: {
    backgroundColor: 'var(--color-line-light)',
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'flex-end',
    marginTop: 6,
    paddingRight: 3,
    paddingBottom: 3,
  } as React.CSSProperties,
  commentButton: {
    marginLeft: 6,
  },
  selectFileButton: {},
  imageAttachment: {
    width: 150,
    height: 150,
    borderRadius: 6,
    marginRight: 12,
    marginBottom: 12,
    backgroundPosition: 'center',
    backgroundRepeat: 'no-repeat',
    backgroundSize: 'cover',
    position: 'relative',
    backgroundColor: 'var(--color-line)',
    border: '1px solid var(--color-line)',
  } as React.CSSProperties,
  imageAttachmentDeleteButton: {
    fontSize: 12,
    width: 20,
    height: 20,
    borderRadius: '50%',
    border: 'none',
    backgroundColor: 'var(--color-muted)',
    color: 'var(--color-white)',
    position: 'absolute',
    top: 4,
    right: 4,
  } as React.CSSProperties,
  generalFileAttachmentDeleteButton: {
    fontSize: 12,
    width: 20,
    height: 20,
    borderRadius: '50%',
    border: 'none',
    backgroundColor: 'var(--color-muted)',
    color: 'var(--color-white)',
    marginLeft: 16,
  },
  fileAttachment: {
    width: 150,
    height: 150,
    marginRight: 12,
    fontSize: 12,
    fontWeight: 500,
    borderRadius: 3,
    padding: '6px 12px',
    backgroundColor: 'var(--color-line)',
    wordWrap: 'break-word',
  } as React.CSSProperties,
  info: {
    width: '100%',
  },
  fileName: {
    fontSize: 16,
  },
  imageAttachmentView: {
    borderRadius: 6,
    marginRight: 12,
    marginBottom: 12,
    backgroundPosition: 'center',
    backgroundRepeat: 'no-repeat',
    backgroundSize: 'cover',
    position: 'relative',
    backgroundColor: 'var(--color-line)',
    border: '1px solid var(--color-line)',
  } as React.CSSProperties,
  fileAttachmentView: {
    fontSize: 16,
    fontWeight: 500,
    borderRadius: 3,
    padding: 12,
    backgroundColor: 'var(--color-line)',
  },
  legalDocumentName: {
    fontSize: 18,
    fontWeight: 700,
    marginBottom: 12,
  },
  userName: {
    fontSize: 14,
    color: 'var(--color-muted)',
  },
  captionText: {
    
  }
};
